/* src/app/private/modules/registration/registration.component.scss */
.action-button {
  color: var(--primary-color);
  cursor: pointer;
  margin-left: 10px;
}
.no-data {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  padding: 20px;
}
::ng-deep .custom-confirm-dialog.p-dialog {
  max-width: 60vw !important;
  width: 60vw !important;
  border-radius: 1rem !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3) !important;
  overflow: visible !important;
}
::ng-deep .custom-confirm-dialog.p-dialog .p-dialog-content {
  padding: 0 !important;
  background: transparent !important;
  overflow: visible !important;
  border-radius: 1rem !important;
}
::ng-deep .custom-confirm-dialog.p-dialog .p-dialog-header {
  display: none !important;
}
::ng-deep .custom-confirm-dialog.p-dialog .p-dialog-footer {
  display: none !important;
}
@keyframes bounce-in {
  0% {
    transform: scale(0) translateY(20px);
    opacity: 0;
  }
  50% {
    transform: scale(1.1) translateY(0);
  }
  100% {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}
::ng-deep .animate-bounce-in {
  animation: bounce-in 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}
/*# sourceMappingURL=registration.component.css.map */
